<template>
  <!-- 多媒体资源入库 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="toStorage"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="toStorage" leftIndex="mediaToStorage"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload"
          @click="firstCreate()"
          >添加资源</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document-add"
          @click="batchUpload()"
          >批量导入</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          @click="downloadImportTemplate()"
          >下载资源导入模板</el-button
        >
      </div>
      <el-table
        :data="listTableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="title"
          show-overflow-tooltip
          min-width="80"
          label="资源名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="type"
          show-overflow-tooltip
          label="类型"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            <span effect="dark" v-if="scope.row.type == 1">图片</span>
            <span effect="dark" v-if="scope.row.type == 2">视频</span>
            <span effect="dark" v-if="scope.row.type == 3">音频</span>
            <span effect="dark" v-if="scope.row.type == 4">3D</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="isOriginal"
          show-overflow-tooltip
          label="有无原始资源"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            <span effect="dark" v-if="scope.row.isOriginal == 10">无</span>
            <span effect="dark" v-if="scope.row.isOriginal == 20">有</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="addTime"
          show-overflow-tooltip
          label="最后修改时间"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
      <!-- 批量导入弹窗 -->
      <el-dialog
        title="批量导入"
        :visible.sync="createUpdateDialog"
        width="600px"
      >
        <div>
          <span>类型：</span>
          <el-select
            placeholder="请选择类型"
            v-model="BUType"
            style="margin-bottom: 20px"
            clearable
          >
            <el-option value="1" label="图片"> </el-option>
            <el-option value="2" label="视频"> </el-option>
            <el-option value="3" label="音频"> </el-option>
            <el-option value="4" label="3D"> </el-option>
          </el-select>
        </div>
        <div>
          <span>分支：</span>
          <!-- 分支树开始 -->
          <el-select
            placeholder="请选择分支"
            v-model="BUSubject"
            style="margin-bottom: 20px"
            clearable
          >
            <el-option :value="dataList"
              ><el-tree
                ref="tree"
                :props="props"
                :load="loadNode"
                check-on-click-node
                highlight-current
                :expand-on-click-node="false"
                @check-change="handleCheckChange"
                node-key="id"
                lazy
              >
              </el-tree>
            </el-option>
          </el-select>
          <!-- 分支树结束 -->
        </div>

        <div class="uploadBox">
          <el-upload
            ref="batchUpload"
            action="/zyk/resource/batchUpload"
            :headers="headers"
            :file-list="fileList"
            name="upfile"
            :before-upload="beforeBatchUploadData"
            :on-success="BUSuccess"
            :on-error="BUError"
            :auto-upload="false"
            accept=".zip"
            :data="batchUploadData"
          >
            <div slot="tip" class="el-upload__tip">
              必须为zip压缩文件,若资源超过4G，请联系管理员。
            </div>
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
            <el-button size="small" type="success" @click="submitbatchUpload"
              >上传并导入</el-button
            >
          </el-upload>
        </div>
      </el-dialog>

      <!-- 添加资源弹窗 -->
      <el-dialog title="添加资源" :visible.sync="createDialog" width="1000px">
        <el-form
          label-width="100px"
          :rules="addRules"
          ref="addForm"
          :model="addForm"
        >
          <el-form-item label="资源标题" style="width: 50%" prop="title">
            <el-input
              v-model="addForm.title"
              placeholder="请输入资源标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="资源名称" style="width: 50%" prop="oldName">
            <el-input
              v-model="addForm.oldName"
              placeholder="请输入资源名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="资源描述">
            <el-input
              type="textarea"
              v-model="addForm.description"
              placeholder="请输入资源描述"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="是否存在原图"
            prop="isOriginal"
            label-width="110px"
          >
            <el-select
              placeholder="是否存在原图"
              v-model="addForm.isOriginal"
              style="width: 100%"
              clearable
            >
              <el-option value="10" label="无"> </el-option>
              <el-option value="20" label="有"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分支" style="width: 50%" prop="subjectId">
            <!-- 分支树开始 -->
            <el-select
              placeholder="请选择分支"
              v-model="selectedValue"
              style="width: 100%"
              clearable
            >
              <el-option :value="dataList"
                ><el-tree
                  ref="tree"
                  :props="props"
                  :load="loadNode"
                  check-on-click-node
                  highlight-current
                  :expand-on-click-node="false"
                  @check-change="handleCheckChange"
                  node-key="id"
                  lazy
                >
                </el-tree>
              </el-option>
            </el-select>
            <!-- 分支树结束 -->
          </el-form-item>
          <el-form-item label="类型" style="width: 50%" prop="type">
            <el-select
              placeholder="请选择类型"
              v-model="addForm.type"
              style="width: 100%"
              @change="addTypeChange"
              clearable
            >
              <el-option value="1" label="图片"> </el-option>
              <el-option value="2" label="视频"> </el-option>
              <el-option value="3" label="音频"> </el-option>
              <el-option value="4" label="3D"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="缩略图" prop="logoPath">
            <div class="uploadBox">
              <el-upload
                class="avatar-uploader"
                ref="logoUpload"
                action="/zyk/resource/upload"
                :headers="headers"
                :show-file-list="false"
                name="upfile"
                :data="upLodeData"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
              >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500KB
                </div>
                <img v-if="logoImgUrl" :src="logoImgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="资源上传" prop="httpPath">
            <div class="uploadBox">
              <el-upload
                ref="zyupload"
                action="/zyk/resource/upload"
                :headers="headers"
                :file-list="fileList"
                name="upfile"
                :before-upload="beforeUpload"
                :on-success="zySuccess"
                :auto-upload="false"
                :accept="acceptType"
                :data="upLodeData"
                :limit="1"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选择文件</el-button
                >
                <el-button size="small" type="success" @click="zySubmitUpload"
                  >开始上传</el-button
                >
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="原图上传" v-if="this.addForm.isOriginal == 20">
            <div class="uploadBox">
              <el-upload
                ref="ytupload"
                action="/zyk/resource/upload"
                :headers="headers"
                :file-list="fileList"
                name="upfile"
                :before-upload="beforeUpload"
                :on-success="yuSuccess"
                :auto-upload="false"
                accept=".zip"
                :data="upLodeData"
                :limit="1"
              >
                <div slot="tip" class="el-upload__tip">
                  必须为zip压缩文件,若资源超过4G，请联系管理员。
                </div>
                <el-button slot="trigger" size="small" type="primary"
                  >选择文件</el-button
                >
                <el-button size="small" type="success" @click="ytSubmitUpload"
                  >开始上传</el-button
                >
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="是否外部资源" style="width: 50%">
            <el-select
              placeholder="是否外部资源"
              v-model="addForm.isOuter"
              style="width: 100%"
              clearable
            >
              <el-option value="10" label="内部资源"> </el-option>
              <el-option value="10" label="外部资源"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="许可期限" style="width: 50%">
            <el-input
              v-model="addForm.permitTime"
              placeholder="请输入许可期限"
            ></el-input>
          </el-form-item>
          <el-form-item label="关键字" style="width: 50%">
            <el-input
              v-model="addForm.word"
              placeholder="请输入关键字"
            ></el-input>
          </el-form-item>
          <el-form-item label="来源" style="width: 50%">
            <el-input
              v-model="addForm.origin"
              placeholder="请输入来源"
            ></el-input>
          </el-form-item>
          <el-form-item label="来源ID" style="width: 50%">
            <el-input
              v-model="addForm.originId"
              placeholder="请输入来源ID"
            ></el-input> </el-form-item
          ><el-form-item label="主讲人" style="width: 50%">
            <el-input
              v-model="addForm.zjr"
              placeholder="请输入主讲人"
            ></el-input> </el-form-item
          ><el-form-item label="主讲人单位" style="width: 50%">
            <el-input
              v-model="addForm.zjrdw"
              placeholder="请输入主讲人单位"
            ></el-input> </el-form-item
          ><el-form-item label="主讲人简介" style="width: 50%">
            <el-input
              v-model="addForm.zjrjj"
              placeholder="请输入主讲人简介"
            ></el-input> </el-form-item
          ><el-form-item label="文字稿">
            <el-input
              type="textarea"
              v-model="addForm.wzg"
              placeholder="请输入文字稿"
              style="width: 100%"
            ></el-input> </el-form-item
          ><el-form-item label="目录">
            <el-input
              type="textarea"
              v-model="addForm.menu"
              placeholder="请输入目录"
              style="width: 100%"
            ></el-input> </el-form-item
          ><el-form-item label="版权" style="width: 50%">
            <el-input
              v-model="addForm.copyright"
              placeholder="请输入版权"
            ></el-input> </el-form-item
          ><el-form-item label="合同期限" style="width: 50%">
            <el-input
              v-model="addForm.contract"
              placeholder="请输入合同期限"
            ></el-input> </el-form-item
          ><el-form-item label="许可类型" style="width: 50%">
            <el-input
              v-model="addForm.permitType"
              placeholder="请输入许可类型"
            ></el-input> </el-form-item
          ><el-form-item label="许可范围" style="width: 50%">
            <el-input
              v-model="addForm.permitScope"
              placeholder="请输入许可范围"
            ></el-input>
          </el-form-item>
          <el-form-item label="资源类别" style="width: 50%">
            <el-input
              v-model="addForm.resourceType"
              placeholder="请输入资源类别"
            ></el-input>
          </el-form-item>
          <el-form-item label="来源方式" style="width: 50%">
            <el-input
              v-model="addForm.dealtype"
              placeholder="请输入来源方式"
            ></el-input>
          </el-form-item>

          <!-- 图片专属input -->
          <div class="picInput" v-if="this.addForm.type == 1">
            <el-form-item label="图片大小" style="width: 50%">
              <el-input
                v-model="addForm.imageRatio"
                placeholder="请输入图片大小"
              ></el-input>
            </el-form-item>
            <el-form-item label="图注" style="width: 50%">
              <el-input
                v-model="addForm.imageNote"
                placeholder="请输入图注"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 音频专属input -->
          <div class="audioInput" v-if="this.addForm.type == 3">
            <el-form-item label="音频语种" style="width: 50%">
              <el-input
                v-model="addForm.audioLanguage"
                placeholder="请输入音频语种"
              ></el-input>
            </el-form-item>
            <el-form-item label="作词" style="width: 50%">
              <el-input
                v-model="addForm.audioWordAuthor"
                placeholder="请输入作词"
              ></el-input>
            </el-form-item>
            <el-form-item label="作曲" style="width: 50%">
              <el-input
                v-model="addForm.audioComposeAuthor"
                placeholder="请输入作曲"
              ></el-input>
            </el-form-item>
            <el-form-item label="演唱者" style="width: 50%">
              <el-input
                v-model="addForm.audioSinger"
                placeholder="请输入演唱者"
              ></el-input>
            </el-form-item>
            <el-form-item label="演奏" style="width: 50%">
              <el-input
                v-model="addForm.audioExecutant"
                placeholder="请输入演奏"
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑" style="width: 50%">
              <el-input
                v-model="addForm.audioAlbum"
                placeholder="请输入专辑"
              ></el-input>
            </el-form-item>
            <el-form-item label="比特率" style="width: 50%">
              <el-input
                v-model="addForm.audioBitRate"
                placeholder="请输入比特率"
              ></el-input>
            </el-form-item>
            <el-form-item label="采样率" style="width: 50%">
              <el-input
                v-model="addForm.audioSamplingRate"
                placeholder="请输入采样率"
              ></el-input>
            </el-form-item>
            <el-form-item label="时长" style="width: 50%">
              <el-input
                v-model="addForm.audioTimeLong"
                placeholder="请输入时长"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 视频专属input -->
          <div class="videoInput" v-if="this.addForm.type == 2">
            <el-form-item label="系列题名" style="width: 50%">
              <el-input
                v-model="addForm.videoSeriesTitle"
                placeholder="请输入系列题名"
              ></el-input>
            </el-form-item>
            <el-form-item label="分集数" style="width: 50%">
              <el-input
                v-model="addForm.videoDiversityTotal"
                placeholder="请输入分集数"
              ></el-input>
            </el-form-item>
            <el-form-item label="色彩" style="width: 50%">
              <el-input
                v-model="addForm.videoColor"
                placeholder="请输入色彩"
              ></el-input>
            </el-form-item>
            <el-form-item label="时代" style="width: 50%">
              <el-input
                v-model="addForm.videoPeriod"
                placeholder="请输入时代"
              ></el-input>
            </el-form-item>
            <el-form-item label="视频声道语种" style="width: 50%">
              <el-input
                v-model="addForm.videoVoice"
                placeholder="请输入视频声道语种"
              ></el-input>
            </el-form-item>
            <el-form-item label="字幕">
              <el-input
                type="textarea"
                v-model="addForm.videoCaption"
                placeholder="请输入字幕"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onCreate('addForm')"
            >确 定</el-button
          >
          <el-button @click="createDialog = false">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 下载资源导入模板弹窗 -->
      <el-dialog
        title="下载资源导入模板"
        :visible.sync="downloadTemplateDialog"
        width="600px"
      >
        <el-select v-model="downloadTemplate" clearable>
          <el-option value="image" label="图片"></el-option>
          <el-option value="video" label="视频"></el-option>
          <el-option value="audio" label="音频"></el-option>
        </el-select>
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="templateDownload"
          >下载</el-button
        >
        <a class="downloadText"></a>
        <span slot="footer" class="dialog-footer">
          <el-button @click="downloadTemplateDialog = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      newType: "",
      // 数据部分
      listTableData: [],
      multipleSelectionTable: [],
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      dataList: [],
      listData: [],
      runtimeKey: "",
      logoImgUrl: "",
      BUType: "",
      BUSubject: "",
      BUSubjectId: "",
      logInterval: null,
      selectedValue: null,
      successTitle: "",
      downloadTemplate: "",
      successContent: "",
      runTimeTitle: "",
      checkLogTitle: "",
      logChechContent: "",
      uploadAccept: "",
      startTime: "",
      acceptType: "",
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
      upLodeData: {
        type: "",
      },
      batchUploadData: {
        type: "",
        subjectId: "",
      },
      addForm: {},

      // 文件上传部分
      fileType: "", // 文件类型
      fileList: [], //上传文件列表

      sourceList: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      sourceContent: "",
      dataText: "",
      activeName: "first",
      optionData: [],

      // 弹窗部分
      createDialog: false,
      transDialog: false,
      logMMesDialog: false,
      successDialog: false,
      checkLogDialog: false,
      uploadPreDialog: false,
      createUpdateDialog: false,
      downloadTemplateDialog: false,
      addRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        subjectId: [{ required: true, trigger: "blur" }],
        oldName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        isOriginal: [
          { required: true, message: "请选择是否有原始资源", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        httpPath: [{ required: true, trigger: "blur" }],
      },
    };
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.getSourceList();
    this.searchParam();
  },
  methods: {
    // 加载数据
    searchParam() {
      let that = this;
      let params = {
        size: this.pageSize,
        page: this.currentPage,
      };
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/resource/resourceInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = response.obj.total;
            that.listTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/subject/resourceSubject?size=1000&page=1",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { flag: 10 },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            return resolve([{ name: "百科数据资源库", id: "-1" }]);
          } else if (node.level == 1) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 时间戳转换
    timestampToDate(timestamp) {
      var date = new Date(timestamp); // 将时间戳转换为Date对象
      return date.toISOString().slice(0, 10); // 将Date对象转换为YYYY-MM-DD格式
    },
    handleCheckChange() {
      let that = this;
      let res = this.$refs.tree.getCurrentNode();
      this.selectedValue = res.name;
      this.BUSubject = res.name;
      that.BUSubjectId = res.id;
      this.addForm.subjectId = res.id;
    },
    // 类型选择改变时，文件类型也改变
    addTypeChange(value) {
      let that = this;
      if (value == 1) {
        that.acceptType = ".jpg,.png,.gif";
      } else if (value == 2) {
        that.acceptType = ".mp4";
      } else if (value == 3) {
        that.acceptType = ".mp3";
      }
    },
    // 显示上传资源包弹框
    firstCreate() {
      // let that = this;
      this.addForm = {};
      this.logoImgUrl = "";
      this.selectedValue = "";
      this.createDialog = true;
    },
    // 获取实时日志
    getRuntimeLog(runtimeKey) {
      let that = this;
      this.logInterval = setInterval(function () {
        $.ajax({
          type: "GET",
          dataType: "json",
          data: { runtimeKey: runtimeKey, timeCurrent: $.now() },
          url: "/zyk/storage/runtimeLog",
          success: function (response) {
            if (response.code == 200) {
              if (response.obj == null) {
                $(".logContent").text("正在操作...");
              } else {
                $(".logContent").text(response.obj);
              }
              if (response.obj.indexOf("转换完成") !== -1) {
                clearInterval(that.logInterval);
                this.successDialog = true;
                this.transDialog = false;
                this.successTitle = "资源包转换结果";
                this.successContent = "转换成功！";
              } else if (response.obj.indexOf("导入完成") !== -1) {
                clearInterval(that.logInterval);
                that.successDialog = true;
                that.transDialog = false;
                that.successTitle = "资源包导入结果";
                that.successContent = "导入成功！";
              } else {
                // console.log("正在操作");
                console.log(response.obj);
              }
            } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            }
          },
          error: function (data) {
            console.log(data);
          },
        });
      }, 1000);
      this.transDialog = true;
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 成功弹窗事件
    successClick() {
      let that = this;
      this.successDialog = false;
      that.searchParam();
    },
    // 选择来源时table刷新
    tableRefresh() {
      let that = this;
      let currentSource = this.sourceContent;
      console.log(currentSource);
      that.searchParam();
    },
    uploadPre() {
      this.uploadPreDialog = true;
    },
    checkLog() {
      this.checkLogDialog = true;
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 文件上传
    zySubmitUpload() {
      this.$refs.zyupload.data.type = this.addForm.type;
      this.$refs.zyupload.submit();
    },
    ytSubmitUpload() {
      this.$refs.ytupload.data.type = this.addForm.type;
      this.$refs.ytupload.submit();
    },
    submitbatchUpload() {
      this.$refs.batchUpload.data.type = this.BUType;
      this.$refs.batchUpload.data.subjectId = this.BUSubjectId;
      this.$refs.batchUpload.submit();
    },

    // 上传文件之前的钩子，对文件大小进行校验
    beforeUpload(file) {
      let that = this;
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        console.log(that.addForm);
        that.upLodeData = {
          type: this.addForm.type,
        };
      }
    },
    beforeBatchUploadData(file) {
      let that = this;
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        that.batchUploadData = {
          type: this.BUType,
          subjectId: this.BUSubjectId,
        };
      }
    },
    // 上传成功的钩子
    zySuccess(response) {
      let that = this;
      console.log(response);
      that.addForm.httpPath = response.obj;
    },
    yuSuccess(response) {
      console.log(response);
      let that = this;
      that.addForm.resourcePath = response.obj;
    },
    BUSuccess(response) {
      let that = this;
      if (response.code == 200) {
        that.$message({
          message: "资源上传成功",
          duration: 2000,
          showClose: true,
          type: "success",
          offset: 100,
        });
        that.searchParam();
        that.createUpdateDialog = false;
      } else {
        that.$message({
          message: response.msg,
          duration: 2000,
          showClose: true,
          type: "error",
          offset: 100,
        });
      }
    },
    BUError(response) {
      let that = this;
      that.$message({
        message: response.msg,
        duration: 2000,
        showClose: true,
        type: "error",
        offset: 100,
      });
    },
    // 提交创建
    onCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          $.ajax({
            url: "/zyk/c/resource/resourceInfo/add",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: that.addForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "资源添加成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    downloadImportTemplate() {
      this.downloadTemplateDialog = true;
    },
    templateDownload() {
      let that = this;
      var downloadA = document.createElement("a");
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/resource/downloadImportTemplate",
        data: { tag: this.downloadTemplate },
        // contentType: "text/xml",
        success: function (response) {
          if (response.code == 200) {
            downloadA.href = response.obj.url;
            downloadA.download;
            downloadA.click();
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    batchUpload() {
      let that = this;
      that.BUType = "";
      that.BUSubjectId = "";
      that.BUSubject = "";
      this.createUpdateDialog = true;
    },
    // 缩略图上传成功钩子
    handleAvatarSuccess(response) {
      let that = this;
      that.logoImgUrl = response.obj;
      that.addForm.logoPath = response.obj;
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type == "image/jpeg";
      const isPNG = file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG或PNG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      } else {
        that.upLodeData = {
          type: this.addForm.type,
        };
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.uploadBox .avatar-uploader .el-upload .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>